require('../../modules/es.symbol.iterator');
require('../../modules/es.string.iterator');
require('../../modules/web.dom-collections.iterator');
var WrappedWellKnownSymbolModule = require('../../internals/well-known-symbol-wrapped');

module.exports = WrappedWellKnownSymbolModule.f('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/symbol/iterator.js
// module id = 1009
// module chunks = 0